import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <Button variant="ghost" size="sm" asChild className="mb-8">
          <Link to="/">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar
          </Link>
        </Button>

        <h1 className="text-3xl font-bold text-foreground mb-8">
          Termos de Uso
        </h1>

        <div className="prose prose-sm dark:prose-invert max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm">
            Última atualização: {new Date().toLocaleDateString("pt-BR", { month: "long", year: "numeric" })}
          </p>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e usar o Next AI Finance, você concorda com estes Termos de Uso.
              Se você não concordar com qualquer parte destes termos, não poderá usar nossos serviços.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">2. Descrição do Serviço</h2>
            <p>
              O Next AI Finance é uma plataforma de gestão financeira pessoal que permite ao usuário
              registrar transações, criar orçamentos, definir metas e gerar relatórios. O serviço
              é fornecido "como está" e pode ser modificado a qualquer momento.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">3. Conta do Usuário</h2>
            <p>
              Você é responsável por manter a confidencialidade da sua conta e senha. Todas as
              atividades realizadas na sua conta são de sua responsabilidade. Notifique-nos
              imediatamente sobre qualquer uso não autorizado.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">4. Planos e Pagamentos</h2>
            <p>
              Oferecemos planos gratuitos e pagos. Os planos pagos são cobrados mensalmente via
              Stripe. Você pode cancelar a qualquer momento, mantendo o acesso até o final do
              período pago. Não oferecemos reembolso por períodos parciais.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">5. Uso Aceitável</h2>
            <p>
              Você concorda em não usar o serviço para atividades ilegais, não tentar acessar
              dados de outros usuários, não interferir no funcionamento da plataforma e não
              realizar engenharia reversa do software.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">6. Propriedade dos Dados</h2>
            <p>
              Seus dados financeiros pertencem a você. Podemos usar dados agregados e anonimizados
              para melhorar o serviço. Você pode exportar ou excluir seus dados a qualquer momento.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">7. Limitação de Responsabilidade</h2>
            <p>
              O Next AI Finance não é um serviço de consultoria financeira. As informações
              apresentadas são para fins organizacionais e não constituem recomendações de
              investimento. Não nos responsabilizamos por decisões financeiras tomadas com
              base nas informações exibidas na plataforma.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">8. Modificações</h2>
            <p>
              Podemos atualizar estes termos periodicamente. Notificaremos sobre alterações
              significativas por e-mail ou por um aviso na plataforma. O uso continuado após
              as alterações constitui aceitação dos novos termos.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">9. Contato</h2>
            <p>
              Para dúvidas sobre estes termos, entre em contato pelo e-mail{" "}
              <a href="mailto:contato@nextaifinance.com" className="text-primary hover:underline">
                contato@nextaifinance.com
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
